import { render, staticRenderFns } from "./FloatingTabs.vue?vue&type=template&id=6da6ce62&scoped=true"
import script from "./FloatingTabs.vue?vue&type=script&lang=ts"
export * from "./FloatingTabs.vue?vue&type=script&lang=ts"
import style0 from "./FloatingTabs.vue?vue&type=style&index=0&id=6da6ce62&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6da6ce62",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6da6ce62')) {
      api.createRecord('6da6ce62', component.options)
    } else {
      api.reload('6da6ce62', component.options)
    }
    module.hot.accept("./FloatingTabs.vue?vue&type=template&id=6da6ce62&scoped=true", function () {
      api.rerender('6da6ce62', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FloatingTabs/FloatingTabs.vue"
export default component.exports